
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/api/box",
      function () {
        return require("private-next-pages/system/api/box.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/api/box"])
      });
    }
  